import React, { useCallback, useEffect, useState } from 'react'
import './Hall.scss'
import { useRecoilValue } from 'recoil'
import { langState } from '../../../atoms'
import { getText } from '../../../data/langs'
import SnowFall from '../SnowFall'
import Missions from '../../containers/Missions'
import Contact from '../Contact'
import AlienDecodeText from '../AlienDecodeText'
import clsx from 'clsx'

const Hall = () => {
  const {value, initialized} = useRecoilValue(langState)
  const text = useCallback((key) => getText(key, value), [value])
  const [mission, setMission] = useState(false)
  useEffect(() => {
    const down = e => {
      console.log(e.key)
      if(e.key.toUpperCase() == 'ESCAPE') setMission(false)
    }
    document.addEventListener('keydown', down)
    return () => document.removeEventListener('keydown', down)
  }, [])
  return (
    <>
       <div className={clsx("Hall", {turned: mission})}>
        <div className="presentation">
          <div className="pr pr-left">
            <div>
              <div className="hello">
                <div className="hi"><AlienDecodeText text={text('greeting')} autoPlay={initialized}/></div>
                <div className="prof"><AlienDecodeText text={text('title')} autoPlay={initialized}/></div>
              </div>
              <div className="details">
                <AlienDecodeText text={text('askmission')} autoPlay={initialized}/><br/>
                <AlienDecodeText text={text('askmission2')} autoPlay={initialized}/>
              </div>
              <div className="stacks sec">
                <div style={{'--name': '"React"'}} className="stack react"/>
                <div style={{'--name': '"Next"'}} className="stack next"/>
                <div style={{'--name': '"Node"'}} className="stack node "/>
                <div style={{'--name': '"See more..."'}} onClick={() => setMission(true)} className="stack more button"></div>
              </div>
            </div>
          </div>
          <div className="pr pr-right">
            <div className="projects">
              <div className="p-proj"><AlienDecodeText text={text('bestprojs')} autoPlay={initialized}/></div>
              <div className="count"><AlienDecodeText text={text('numberprojs')} autoPlay={initialized}/></div>
              <div className="thisyear"><AlienDecodeText text={text('andcontinues')} autoPlay={initialized}/> <span className="thisyear-nb"><span>{new Date().getFullYear()}</span></span></div>
            </div>
          </div>
        </div>
      </div>
      {<SnowFall active={mission}/>}
      {<Missions active={mission} close={() => setMission(false)}/>}
      <Contact/>
    </>
  )
}
export default Hall
